// Raw px breakpoint values — the single source of truth shared by both the
// styled-components media helper (src/styles/media.js) and the JS useMediaQuery
// hook (src/hooks/useMediaQuery.js), so CSS and JS can never drift apart.
export const BREAKPOINTS = {
  mobile: 600, // <= 600  -> phones: single column, full-width modals
  tablet: 1024, // <= 1024 -> tablets/phones: sidebar collapses to a drawer
  desktop: 1200, // dense-table comfort floor (per-page use)
};

// Pre-built max-width query strings consumed by both the CSS helper and the hook.
export const MEDIA_QUERY = {
  maxMobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
  maxTablet: `(max-width: ${BREAKPOINTS.tablet}px)`,
  maxDesktop: `(max-width: ${BREAKPOINTS.desktop}px)`,
};
